// extracted by mini-css-extract-plugin
export default {"titan":"BackButton_titan__yrlbF","gt":"BackButton_gt__rD5D0","backButton":"BackButton_backButton__8IViP"};